// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3192":"d01e581d","3833":"00a8929e","4948":"ffa47f6e"}[chunkId] + ".chunk.css";
};